/**
 * Public brand / product asset paths (local `public/` + Supabase CDN).
 * Prefer these constants over string literals so URLs stay one place to change.
 */

export const SUPABASE_PUBLIC_STORAGE_BASE =
  'https://ndmqjcvtrbyznxubmswq.supabase.co/storage/v1/object/public';

export const BRAND_ASSETS = {
  gourmex: {
    favicon: '/favicon.ico',
    logo: '/Gourmex_preto_bgtransparente.png',
    mark: '/logo.png',
  },
  foodstation: {
    favicon: '/food_favicon.ico',
    logo: '/foodstation.png',
    mark: '/foodstation.png',
  },
  atendabot: {
    /** Logo institucional / favicon do domínio AtendaBot */
    logo: '/logoatendabot.png',
    mark: '/logoatendabot.png',
    favicon: '/logoatendabot.png',
    /** Arte de produto (catálogo, LP, cards Foodstation) */
    product: '/novoatendabot.png',
  },
};

/** Imagens de produto em `public/` (catálogo, sidebars, LPs). */
export const PRODUCT_IMAGES = {
  atendabot: BRAND_ASSETS.atendabot.product,
  feedbackHero: '/feedback.png',
  reservo: '/Reservo1.png',
  oneMenu: '/onemenu.png',
  cv: '/curriculo.jpg',
  linkPage: '/linkpagefundo.png',
  smartCampaigns: '/smart-campaigns.png',
  clientCenter: '/clientcenter.png',
  clientCenterDark: '/clientcenterdark.png',
  clube: '/clube.png',
  chefList: '/cheflist.png',
  confereAi: '/confereai.jpg',
  reservoIcon: '/Reservo-icon.png',
  linkPageMark: '/linkpage.png',
};

export const PUBLIC_MEDIA = {
  whatsappIcon: `${SUPABASE_PUBLIC_STORAGE_BASE}/support-bot-avatars/products/wpp.png`,
  clubeQrDisplayFoodstation: `${SUPABASE_PUBLIC_STORAGE_BASE}/qrcode/3/qr_display_foodstation.jpg`,
};

/** Atalhos usados fora do mapa de host */
export const ATENDABOT_LOGO = BRAND_ASSETS.atendabot.logo;
export const ATENDABOT_PRODUCT_IMAGE = BRAND_ASSETS.atendabot.product;
export const FOODSTATION_LOGO = BRAND_ASSETS.foodstation.logo;
export const FEEDBACK_HERO_IMAGE = PRODUCT_IMAGES.feedbackHero;
export const RESERVO_IMAGE = PRODUCT_IMAGES.reservo;
export const ONE_MENU_IMAGE = PRODUCT_IMAGES.oneMenu;
export const CV_IMAGE = PRODUCT_IMAGES.cv;
export const LINK_PAGE_IMAGE = PRODUCT_IMAGES.linkPage;
export const SMART_CAMPAIGNS_IMAGE = PRODUCT_IMAGES.smartCampaigns;
